import axios from "@axios";
import store from "@/store";
import { useUtils as useI18nUtils } from "@core/libs/i18n";

export default {
  namespaced: true,
  state: {
    url: '',
    aiComment: '',
    images: [],
    index: 0,
  },
  getters: {
    getImageUrl(state){
      return state.url;
    }
  },
  mutations: {
    setImageUrl(state, value){
      state.url = value;
    },
    setAiComment(state, value){
      state.aiComment = value;
    },
    setAiComment(state, value){
      state.aiComment = value;
    },
    setImagesUrl(state, images) {
      state.images = images
      state.index = 0
    },
    setImageIndex(state, index) {
      state.index = index
      state.url = state.images[index]?.url || ''
    }
  },
  actions: {
    imageUrl({ commit, state }, params) {
      commit("setImageUrl", params);
    },
    aiComment({ commit, state }, params) {
      commit("setAiComment", params);
    },
    imageList({ commit }, images) {
      commit('setImagesUrl', images)
    },
    imageIndex({ commit }, index) {
      commit('setImageIndex', index)
    },
  },
};
